<template>
	<div v-if='penalties.length'>
		<div class="divider"></div>

		<p class='a-hotel-card-details-footer-text'>{{$t('account.result.terms_of_cancellation')}}</p>
		<p class='a-hotel-card-details-with-icon a-hotel-card-details-policy green--text' v-if='freeCancellationUntil'>
			<v-icon icon='check' size='12' />
			<span>{{$t('account.result.free_cancellation_until')}} {{freeCancellationUntil}}</span>
		</p>
		<p class='a-hotel-card-details-with-icon a-hotel-card-details-policy red--text' v-else-if='isNonRefundable'>
			<v-icon icon='cross' size='12' />
			<span>{{$t('account.result.non_refundable')}}</span>
		</p>
		<p class='a-hotel-card-details-with-icon a-hotel-card-details-policy a-hotel-card-details-policy-penalty' v-for='(item, i) in penalties' :key='i'>
			<v-icon icon='timer' size='12' />
			<span>{{$t('account.result.after')}} {{$moment(item.from).format('DD.MM.YYYY')}} — <b>{{$helpers.amount(item.amount, currency)}}</b></span>
		</p>
	</div>
</template>

<script>
	// Условия отмены тарифа отеля: карточка выбора тарифа и карточка отеля в заказе.
	// policies — штрафы в ценах агента, amount — цена агента, с которой их сравниваем.
	export default {
		props: ['policies', 'amount', 'currency'],
		computed: {
			// Реальные штрафы: нулевые (так часть поставщиков помечает конец бесплатного
			// окна) не выводим, суммы — числами (в заказе они приходят строками), и штраф
			// с той же суммой, что и предыдущий, не повторяем.
			penalties() {
				return (this.policies || [])
					.map(item => ({ from: item.from, amount: Number(item.amount) }))
					.filter(item => item.amount > 0)
					.filter((item, i, all) => i === 0 || item.amount !== all[i - 1].amount);
			},
			// Бесплатно — пока не наступил первый ненулевой штраф.
			freeCancellationUntil() {
				const first = this.penalties[0];
				if (!first || this.$moment(first.from).isBefore(this.$moment())) return null;

				return this.$moment(first.from).format('DD.MM.YYYY');
			},
			// Невозвратный — первый штраф уже действует и равен всей сумме.
			isNonRefundable() {
				if (this.freeCancellationUntil) return false;

				const first = this.penalties[0];

				return Boolean(first) && first.amount >= Number(this.amount);
			}
		}
	}
</script>

<style lang="scss">
	@import "@/styles/global/variables";

	.a-hotel-card-details-policy {
		font-size: 13px;
		font-weight: 400;
		color: $black;
		&:not(:last-child) {
			margin-bottom: 3px;
		}
		// Иконка цвета текста: крестик у невозвратного — красный. Специфичнее
		// общего правила строк с иконками (card-details.scss), где иконки чёрные.
		&.a-hotel-card-details-with-icon .app-icon {
			color: currentColor;
		}
		&-penalty.a-hotel-card-details-with-icon .app-icon {
			color: rgba($black, .4);
		}
	}
</style>
